import { ActionIconPipe } from './action-icon.pipe';
import { AllowPhotosPipe } from './allow-photos.pipe';
import { AvatarsPipe } from './avatars.pipe';
import { BestRolePipe } from './best-role.pipe';
import { CustomerSelectionPipe } from './customer-selection.pipe';
import { DatePipe } from './date.pipe';
import { DisplayNamePipe } from './display-name.pipe';
import { DisplayRolesPipe } from './display-roles.pipe';
import { DistanceToPipe } from './distance-to.pipe';
import { DistancePipe } from './distance.pipe';
import { FeaturedImagePipe } from './featured-image.pipe';
import { FeedbackCountPipe } from './feedback-count.pipe';
import { FilesizePipe } from './filesize.pipe';
import { FormatAddressPipe } from './format-address.pipe';
import { MediaIsVideoPipe } from './media-is-video.pipe';
import { MediaPreviewPipe } from './media-preview.pipe';
import { MediaPurposePipe } from './media-purpose.pipe';
import { MediaVariantPipe } from './media-variant.pipe';
import { MemberExternalIdPipe } from './member-external-id.pipe';
import { OrganisationRelativeLink } from './organisation-relative-link.pipe';
import { PureSlicePipe } from './pure-slice.pipe';
import { RolePipe } from './role.pipe';
import { ScoreIconPipe } from './score-icon.pipe';
import { SnakeCaseToProsePipe } from './snake-case-to-prose.pipe';
import { SortByDistancePipe } from './sort-by-distance.pipe';
import { SortByPipe } from './sort-by-pipe.pipe';
import { TranslateRolesPipe } from './translate-roles.pipe';
import { VideoIsReadyPipe } from './video-is-ready.pipe';
import { FilterPipe } from './filter.pipe';
import { HtmlStyleInjectorPipe } from './html-style-injector.pipe';
import { FromNowPipe } from './from-now.pipe';
import { ArrayIncludesPipe } from './array-includes.pipe';
import { IsAnnouncementPinnedPipe } from './is-announcement-pinned.pipe';
import { InvitePermissionsAreValidPipe } from '../../organisation/pipes/invite-permissions-are-valid.pipe';
import { MediaBlurUrlPipe } from './media-blur-url.pipe';
import { FileDownloadUrlPipeV2 } from './file-download-url-v2.pipe';
import { ContentTypeIconPipe } from './content-type-icon.pipe';
import { CustomersFromIdsPipe } from './customers-from-ids.pipe';
import { ArrayIncludesArray } from './array-includes-array.pipe';
import { OrganisationFromIdPipe } from './organisation-from-id.pipe';
import { FormattedListPipe } from './formatted-list.pipe';
import { OrganisationSummaryPipe } from './organisation-summary-pipe';
import { UnixToDatePipe } from './unix-to-date.pipe';
import { ObjectArrayIncludesIdPipe } from './object-array-includes-id.pipe';
import { IdsFromObjectArrayPipe } from './ids-from-object-array.pipe';
import { ParseBooleanPipe } from './parse-boolean-pipe';
import { MemberFilterPipe } from '../member-filter-pipe/member-filter.pipe';

export * from './action-icon.pipe';
export * from './allow-photos.pipe';
export * from './best-role.pipe';
export * from './customer-selection.pipe';
export * from '../member-filter-pipe/member-filter.pipe';
export * from './date.pipe';
export * from './display-name.pipe';
export * from './display-roles.pipe';
export * from './featured-image.pipe';
export * from '../../feed/pipes/feed-item-link.pipe';
export * from './feedback-count.pipe';
export * from './file-download-url-v2.pipe';
export * from './filesize.pipe';
export * from './format-address.pipe';
export * from './ids-from-object-array.pipe';
export * from './media-blur-url.pipe';
export * from './media-is-video.pipe';
export * from './media-preview.pipe';
export * from './media-purpose.pipe';
export * from './media-variant.pipe';
export * from './member-external-id.pipe';
export * from './organisation-relative-link.pipe';
export * from './organisation-from-id.pipe';
export * from './parse-boolean-pipe';
export * from './role.pipe';
export * from './score-icon.pipe';
export * from './snake-case-to-prose.pipe';
export * from './sort-by-pipe.pipe';
export * from './translate-roles.pipe';
export * from './video-is-ready.pipe';
export * from './html-style-injector.pipe';
export * from '../../ca-design/pipes/country-flag.pipe';
export * from './from-now.pipe';
export * from './array-includes.pipe';
export * from './is-announcement-pinned.pipe';
export * from './customers-from-ids.pipe';
export * from './array-includes-array.pipe';
export * from './organisation-summary-pipe';
export * from './unix-to-date.pipe';
export * from './object-array-includes-id.pipe';

export const PIPES = [
  ActionIconPipe,
  AllowPhotosPipe,
  AvatarsPipe,
  ArrayIncludesArray,
  BestRolePipe,
  ContentTypeIconPipe,
  CustomersFromIdsPipe,
  CustomerSelectionPipe,
  MemberFilterPipe,
  DatePipe,
  DisplayNamePipe,
  DisplayRolesPipe,
  DistancePipe,
  DistanceToPipe,
  FeaturedImagePipe,
  FeedbackCountPipe,
  FileDownloadUrlPipeV2,
  FilesizePipe,
  FilterPipe,
  FormattedListPipe,
  FormatAddressPipe,
  IdsFromObjectArrayPipe,
  MediaBlurUrlPipe,
  MediaIsVideoPipe,
  MediaVariantPipe,
  MediaPreviewPipe,
  MediaPurposePipe,
  MemberExternalIdPipe,
  ObjectArrayIncludesIdPipe,
  OrganisationFromIdPipe,
  OrganisationRelativeLink,
  OrganisationSummaryPipe,
  ParseBooleanPipe,
  PureSlicePipe,
  RolePipe,
  ScoreIconPipe,
  SortByDistancePipe,
  SortByPipe,
  TranslateRolesPipe,
  VideoIsReadyPipe,
  SnakeCaseToProsePipe,
  HtmlStyleInjectorPipe,
  FromNowPipe,
  ArrayIncludesPipe,
  IsAnnouncementPinnedPipe,
  InvitePermissionsAreValidPipe,
  UnixToDatePipe,
];
